module.exports = __webpack_public_path__ + "static/img/douyin.8695284.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zbqfBrand/douyin.png
// module id = X0FD
// module chunks = 0